<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-toc-title">
    Table of Contents
  </div>
<div class="sgc-toc-level-1">
<span href="#/Text/Section0001#sigil_toc_id_1" title="Link target outside of Sample">Preface and Guidance Notes</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Section0001#sigil_toc_id_2" title="Link target outside of Sample">Ionian Licks</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Section0001#sigil_toc_id_3" title="Link target outside of Sample">C Ionian Scales</span>
<div class="sgc-toc-level-3">
<span href="#/Text/Section0001#sigil_toc_id_4" title="Link target outside of Sample">Lick 1</span>
</div>
<div class="sgc-toc-level-3">
<span href="#/Text/Section0001#sigil_toc_id_5" title="Link target outside of Sample">Lick 2</span>
</div>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Section0001#sigil_toc_id_6" title="Link target outside of Sample">F Ionian Licks</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Section0001#sigil_toc_id_7" title="Link target outside of Sample">Lick 1</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Section0001#sigil_toc_id_8" title="Link target outside of Sample">Lick 2</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Section0001#sigil_toc_id_9" title="Link target outside of Sample">Dorian Licks</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Section0001#sigil_toc_id_10" title="Link target outside of Sample">Bb Dorian Scales</span>
<div class="sgc-toc-level-3">
<span href="#/Text/Section0001#sigil_toc_id_11" title="Link target outside of Sample">Lick 1</span>
</div>
<div class="sgc-toc-level-3">
<span href="#/Text/Section0001#sigil_toc_id_12" title="Link target outside of Sample">Lick 2</span>
</div>
<div class="sgc-toc-level-3">
<span href="#/Text/Section0001#sigil_toc_id_13" title="Link target outside of Sample">Lick 3</span>
</div>
<div class="sgc-toc-level-3">
<span href="#/Text/Section0001#sigil_toc_id_14" title="Link target outside of Sample">Lick 4</span>
</div>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Section0001#sigil_toc_id_15" title="Link target outside of Sample">Phrygian Licks</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Section0001#sigil_toc_id_16" title="Link target outside of Sample">C# Phrygian Scales</span>
<div class="sgc-toc-level-3">
<span href="#/Text/Section0001#sigil_toc_id_17" title="Link target outside of Sample">Lick 1</span>
</div>
<div class="sgc-toc-level-3">
<span href="#/Text/Section0001#sigil_toc_id_18" title="Link target outside of Sample">Lick 2</span>
</div>
<div class="sgc-toc-level-3">
<span href="#/Text/Section0001#sigil_toc_id_19" title="Link target outside of Sample">Lick 3</span>
</div>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Section0001#sigil_toc_id_20" title="Link target outside of Sample">Lydian Licks</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Section0001#sigil_toc_id_21" title="Link target outside of Sample">C Lydian Scales</span>
<div class="sgc-toc-level-3">
<span href="#/Text/Section0001#sigil_toc_id_22" title="Link target outside of Sample">Lick 1</span>
</div>
<div class="sgc-toc-level-3">
<span href="#/Text/Section0001#sigil_toc_id_23" title="Link target outside of Sample">Lick 2</span>
</div>
<div class="sgc-toc-level-3">
<span href="#/Text/Section0001#sigil_toc_id_24" title="Link target outside of Sample">Lick 3</span>
</div>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Section0001#sigil_toc_id_25" title="Link target outside of Sample">Mixolydian Licks</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Section0001#sigil_toc_id_26" title="Link target outside of Sample">G Mixolydian Scales</span>
<div class="sgc-toc-level-3">
<span href="#/Text/Section0001#sigil_toc_id_27" title="Link target outside of Sample">Lick 1</span>
</div>
<div class="sgc-toc-level-3">
<span href="#/Text/Section0001#sigil_toc_id_28" title="Link target outside of Sample">Lick 2</span>
</div>
<div class="sgc-toc-level-3">
<span href="#/Text/Section0001#sigil_toc_id_29" title="Link target outside of Sample">Lick 3</span>
</div>
<div class="sgc-toc-level-3">
<span href="#/Text/Section0001#sigil_toc_id_30" title="Link target outside of Sample">Lick 4</span>
</div>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Section0001#sigil_toc_id_31" title="Link target outside of Sample">Aeolian Licks</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Section0001#sigil_toc_id_32" title="Link target outside of Sample">B Aeolian Scales</span>
<div class="sgc-toc-level-3">
<span href="#/Text/Section0001#sigil_toc_id_33" title="Link target outside of Sample">Lick 1</span>
</div>
<div class="sgc-toc-level-3">
<span href="#/Text/Section0001#sigil_toc_id_34" title="Link target outside of Sample">Lick 2</span>
</div>
<div class="sgc-toc-level-3">
<span href="#/Text/Section0001#sigil_toc_id_35" title="Link target outside of Sample">Lick 3</span>
</div>
<div class="sgc-toc-level-3">
<span href="#/Text/Section0001#sigil_toc_id_36" title="Link target outside of Sample">Lick 4</span>
</div>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Section0001#sigil_toc_id_37" title="Link target outside of Sample">Locrian Licks</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Section0001#sigil_toc_id_38" title="Link target outside of Sample">D Locrian Scales</span>
<div class="sgc-toc-level-3">
<span href="#/Text/Section0001#sigil_toc_id_39" title="Link target outside of Sample">Lick 1</span>
</div>
<div class="sgc-toc-level-3">
<span href="#/Text/Section0001#sigil_toc_id_40" title="Link target outside of Sample">Lick 2</span>
</div>
<div class="sgc-toc-level-3">
<span href="#/Text/Section0001#sigil_toc_id_41" title="Link target outside of Sample">Lick 3</span>
</div>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Section0001#sigil_toc_id_42" title="Link target outside of Sample">Thank you for buying this Book</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Section0001#sigil_toc_id_43" title="Link target outside of Sample">eBooks &amp; Books Also Available</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?596e8c89